import { Avatar, Button, Chip, Grid, Typography } from '@mui/material';
import {
  CONTACT_METHOD_TYPE,
  USER_INVITATION_STATUS,
  UserInvitation,
} from 'vendor-marketplace-shared-library';
import { expiresInDays, formatPhoneNumber } from '../../utilities/formatters';

type UserInvitationCardProps = {
  userInvitation: UserInvitation;
  disabledUserInvitationIds: string[];
  onResendInvitation: (userInvitationId: string) => void;
  onCancelInvitation: (userInvitationId: string) => void;
  onDeleteInvitation: (userInvitationId: string) => void;
};
export default function UserInvitationCard(props: UserInvitationCardProps) {
  return (
    <Grid container key={props.userInvitation.id} sx={styles.mainContainer} direction={'column'}>
      <Grid item container xs={12} sx={styles.subContainer}>
        <Grid item container direction={'row'} sx={styles.nameContainer}>
          <Grid item>
            <Avatar />
          </Grid>
          <Grid item container direction={'column'}>
            <Grid item>
              <Typography>{`${props.userInvitation.firstName} ${props.userInvitation.lastName}`}</Typography>
            </Grid>
            <Grid item>
              <Typography variant={'caption'} color={'secondary.main'}>
                {props.userInvitation.userRole?.name ?? 'No role'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant={'caption'} color={'secondary.main'} noWrap>
            {props.userInvitation.contactMethod?.type === CONTACT_METHOD_TYPE.PHONE
              ? formatPhoneNumber(props.userInvitation.contactMethod?.value)
              : props.userInvitation.contactMethod?.value || ''}
          </Typography>
        </Grid>
      </Grid>

      <Grid item container xs={12} direction={'row'} sx={styles.expireContainer}>
        <Grid item sx={{ flexWrap: 'nowrap' }}>
          {props.userInvitation.inviteStatus === USER_INVITATION_STATUS.EXPIRED ? (
            <Chip label={'Expired'} color='error' size={'small'} />
          ) : (
            <Typography
              noWrap
              variant={'caption'}
              color={'secondary.main'}
              sx={{ flexWrap: 'nowrap' }}
            >
              {props.userInvitation.expiresAt
                ? `Expires in ${expiresInDays(props.userInvitation.expiresAt)} day${
                    expiresInDays(props.userInvitation.expiresAt) !== 1 ? 's' : ''
                  }`
                : 'No expiration'}
            </Typography>
          )}
        </Grid>
        <Grid item container direction={'row'} sx={{ justifyContent: 'flex-end' }}>
          <Grid item>
            <Button
              onClick={() => {
                props.userInvitation.inviteStatus === USER_INVITATION_STATUS.EXPIRED
                  ? props.onDeleteInvitation(props.userInvitation.id)
                  : props.onCancelInvitation(props.userInvitation.id);
              }}
            >
              Discard
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={props.disabledUserInvitationIds.includes(props.userInvitation.id)}
              onClick={() => props.onResendInvitation(props.userInvitation.id)}
            >
              {props.disabledUserInvitationIds.includes(props.userInvitation.id)
                ? 'Sent'
                : 'Re-invite'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    backgroundColor: 'white',
    padding: 1,
    borderRadius: 1,
    minWidth: 260,
    rowGap: 2,
    border: '1px solid black',
  },
  nameContainer: {
    flexWrap: 'nowrap',
    columnGap: 1,
  },
  subContainer: {
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
  },
  expireContainer: {
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
};
